<template>
  <div class="unaudited-customer">
    <crm-panel :title="'客户申请中'">
      <span class="mt20"></span>
      <el-table
        :data="customerApplyList && customerApplyList.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column label="提交日期" align="center">
          <template slot-scope="scope">
            {{ scope.row.gmtCreated | formatTimeShow }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="客户名称" align="center"> </el-table-column>
        <el-table-column label="客户类型" align="center">
          <template slot-scope="scope">
            {{ scope.row.categoryName }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="地区" align="center">
          <template slot-scope="{ row }">
            {{ [row.province, row.city, row.district].filter(Boolean).join("/") }}
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="审核状态" align="center">
          <template slot-scope="scope">
            {{ auditStatusDesc(scope.row.auditStatus) }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="审核备注" align="center"> </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <!-- 未审核 || 有searchUid，只允许查看 -->
            <el-button
              v-if="row.auditStatus === 0 || row.searchUid"
              @click="toCustomDetail(row)"
              type="text"
              size="small"
            >
              查看
            </el-button>
            <!-- 被驳回 && 没有searchUid，可以修改 -->
            <el-button
              v-if="row.auditStatus === 3 && !row.searchUid"
              @click="toCustomCorrection(row)"
              type="text"
              size="small"
            >
              修改
            </el-button>
            <el-button
              v-if="auth.customerDeleteApply && auth.customerDeleteApply.toggleStatus"
              @click="delCustom(row)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageObj.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next"
          :total="customerApplyList && customerApplyList.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <correction-custom
      v-if="correctionCustomVisible"
      :row="correctionRow"
      @closeCorrectionCustom="closeCorrectionCustom"
    >
    </correction-custom>

    <check-detail
      v-if="detail.visible"
      :detail="detail"
      :isFromCustom="true"
      @close="handleDetailClose"
    >
    </check-detail>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { formatTimeShow } from "@/scripts/utils";
import CrmPanel from "@/components/base/crmPanel";
import CorrectionCustom from "@/components/business/custom/correctionCustom";
import CheckDetail from "~component/business/audit/checkDetail";
import apiCustomer from "~api/customer";

export default {
  components: {
    CrmPanel,
    CorrectionCustom,
    CheckDetail,
  },
  filters: {
    formatTimeShow,
  },
  data() {
    return {
      loading: true,
      time: [],
      pageObj: {
        pageNumber: 1,
        pageSize: 10,
      },
      correctionCustomVisible: false,
      correctionRow: {},
      detail: {
        visible: false,
        uid: null,
        type: null,
        isAudit: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      customerApplyList: "customer/customerApplyList",
      auth: "authority/auth",
    }),
  },
  created() {
    this.getCustomerApplyList(this.pageObj).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    ...mapActions({
      getCustomerApplyList: "customer/getCustomerApplyList",
    }),
    // 跳转详情页
    toCustomDetail(row) {
      this.detail = {
        visible: true,
        uid: row.uid,
        type: row.type,
      };
      // const type = row.type.toString();
      // this.$router.push({
      //   name: 'customerDetail',
      //   params: { uid: row.uid, type },
      // });
    },
    handleDetailClose() {
      this.detail.visible = false;
    },
    // 跳转到客户修正
    toCustomCorrection(row) {
      // const type = row.type.toString();
      this.correctionRow = row;
      this.correctionCustomVisible = true;
    },
    closeCorrectionCustom() {
      this.correctionCustomVisible = false;
      this.getCustomerApplyList(this.pageObj).finally(() => {
        this.loading = false;
      });
    },
    // 删除客户
    delCustom(row) {
      const params = {
        uid: [row.uid],
        type: row.type,
        teamId: row.teamId,
      };
      this.$confirm("此操作将永久删除该申请记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        apiCustomer
          .apiDeleteingCustom(params)
          .then(() => {
            this.getCustomerApplyList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {});
      });
    },
    auditStatusDesc(code) {
      switch (code) {
        case 0:
          return "未审核";
        case 1:
          return "审核中";
        case 2:
          return "已通过";
        case 3:
          return "已驳回";
        default:
          return "";
      }
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.pageObj.pageSize = val;
      this.pageObj.pageNumber = 1;

      this.getCustomerApplyList(this.pageObj);
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.pageObj.pageNumber = val;
      this.getCustomerApplyList(this.pageObj);
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less";

.unaudited-customer {
  display: flex;
  flex: 1;
  width: 100%;
}
</style>
